module.exports = __webpack_public_path__ + "static/media/lBanner2.d4aa4270.png";